import { Pipe, PipeTransform } from '@angular/core';
import { removeGoogleTranslation } from './remove-google-translation';

@Pipe({
  name: 'transformReviewContent',
  standalone: false,
})
export class TransformReviewContentPipe implements PipeTransform {
  transform(content: string, options?: { hideEnglishTranslations?: boolean }): string {
    if (options.hideEnglishTranslations) {
      return removeGoogleTranslation(content);
    }

    return content;
  }
}
